export const ASSETS = {
    logo: "https://customer-assets.emergentagent.com/job_commerce-mastery-8/artifacts/1xt1oe4y_logo.png",
    mentor: "https://customer-assets.emergentagent.com/job_commerce-mastery-8/artifacts/ktx68kya_mentor.jpg.jpeg",
};

export const SITE = {
    name: "Conceptual Studies",
    tagline: "Strong Concepts Today. Confident Results Tomorrow.",
    supporting: "Helping Commerce Students Learn with Clarity, Confidence and Consistency.",
    phone: "+91 9318369503",
    phoneDigits: "919318369503",
    email: "info@conceptualstudies.in",
    instagram: "https://www.instagram.com/conceptual.studies?utm_source=qr",
    whatsappMessage: "Hi, I'd like to book a free demo class at Conceptual Studies.",
    mentor: {
        name: "Komal Sejwal",
        credentials: ["PhD Scholar", "NET JRF", "SRF", "CA Intermediate"],
        experience: "10+ Years Teaching Experience",
        philosophy: "If you understand the concept, you can solve any question.",
    },
};

export const SUBJECTS = [
    {
        slug: "accountancy",
        title: "Accountancy",
        kicker: "Class 11 + Class 12 + CUET",
        summary: "Master journal entries, partnership and company accounts with concept-first teaching that makes complex topics simple.",
        topics: [
            "Journal Entries",
            "Ledger Posting",
            "Trial Balance",
            "Financial Statements",
            "Partnership Accounts",
            "Company Accounts",
            "Cash Flow Statements",
        ],
        image: "https://images.pexels.com/photos/6238048/pexels-photo-6238048.jpeg?auto=compress&cs=tinysrgb&w=940",
    },
    {
        slug: "economics",
        title: "Economics",
        kicker: "Micro + Macro + CUET",
        summary: "Understand the why behind every concept — from consumer behaviour to national income — with diagrams, examples and intuition.",
        topics: [
            "Microeconomics",
            "Macroeconomics",
            "National Income",
            "Government Budget",
            "Balance of Payments",
            "Money & Banking",
            "Indian Economic Development",
        ],
        image: "https://images.pexels.com/photos/5905709/pexels-photo-5905709.jpeg?auto=compress&cs=tinysrgb&w=940",
    },
    {
        slug: "business-studies",
        title: "Business Studies",
        kicker: "Class 11 + Class 12 + CUET",
        summary: "Beyond rote learning — case studies, real-world applications and structured answer-writing that turns theory into top marks.",
        topics: [
            "Nature of Business",
            "Forms of Business Organisation",
            "Business Services",
            "Principles of Management",
            "Marketing",
            "Business Environment",
            "Financial Management",
        ],
        image: "https://images.pexels.com/photos/4144101/pexels-photo-4144101.jpeg?auto=compress&cs=tinysrgb&w=940",
    },
];

export const CRASH_COURSES = [
    { title: "Partnership Accounts", desc: "Focused crash course on admission, retirement, death & dissolution.", duration: "3 weeks" },
    { title: "Basic Accountancy Foundation", desc: "Strong Class 11 foundation — journal, ledger, trial balance & financial statements.", duration: "4 weeks" },
    { title: "Company Accounts", desc: "Shares, debentures & redemption made simple with concept-first teaching.", duration: "3 weeks" },
    { title: "Board Revision Program", desc: "Full-syllabus revision designed for the final 60 days before boards.", duration: "8 weeks" },
    { title: "Exam Strategy Sessions", desc: "Time management, paper attempt strategy & answer-writing workshops.", duration: "1 week" },
    { title: "Last Minute Revision", desc: "High-yield revision for the last 7 days — formulas, formats, keywords.", duration: "1 week" },
];

export const CUET_FEATURES = [
    "Accountancy Domain Preparation",
    "Business Studies Domain Preparation",
    "Economics Domain Preparation",
    "Mock Tests with detailed analysis",
    "Concept Revision sessions",
    "Exam Strategy & Time Management",
    "Practice Sessions weekly",
];

export const WHY_US = [
    { title: "Concept Clarity", desc: "Every topic taught from first principles — not memorisation." },
    { title: "Personalized Attention", desc: "Small batches ensure every doubt is addressed." },
    { title: "Structured Learning", desc: "Clear monthly roadmap aligned with the board calendar." },
    { title: "Exam Readiness", desc: "Past papers, mock tests and writing practice from day one." },
    { title: "Regular Assessments", desc: "Weekly tests with detailed feedback and improvement plans." },
    { title: "Parent Communication", desc: "Monthly progress reports and direct mentor access." },
];

export const OUTCOMES = [
    "Strong Conceptual Clarity",
    "Better Board Scores",
    "Confidence in Accountancy",
    "Better Exam Writing Skills",
    "Strong Commerce Foundation",
    "Improved Academic Performance",
];

export const JOURNEY = [
    { step: "Demo Class", desc: "Experience our teaching approach risk-free." },
    { step: "Enrollment", desc: "Pick a program that matches your goals." },
    { step: "Concept Building", desc: "Topic-by-topic clarity with examples." },
    { step: "Practice & Assessments", desc: "Weekly tests and detailed feedback." },
    { step: "Revision & Strategy", desc: "Smart revision and exam tactics." },
    { step: "Board / CUET Success", desc: "Walk into the exam hall confident." },
];

export const FAQS = [
    { q: "Which classes do you teach?", a: "We teach Class 11 and Class 12 Commerce students, along with CUET aspirants preparing for the commerce domain." },
    { q: "Which boards are covered?", a: "CBSE, ISC, HBSE and all major State Boards. Our curriculum is mapped to each board's syllabus." },
    { q: "Which subjects are taught?", a: "We offer full-syllabus coverage of Accountancy, Economics and Business Studies, along with crash courses on specific topics." },
    { q: "Do you provide CUET preparation?", a: "Yes. Our CUET Commerce Preparation program covers all three domain subjects with weekly mocks and detailed analysis." },
    { q: "Are crash courses available?", a: "Yes — crash courses include Partnership Accounts, Company Accounts, Board Revision, Last Minute Revision and Exam Strategy Sessions." },
    { q: "Can I attend a demo class?", a: "Absolutely. Book a free demo class through the form below or call us at +91 9318369503." },
    { q: "How are classes conducted?", a: "All classes are live and interactive via Zoom. Every class is recorded so students can revise anytime. Doubt-clearing happens live and through dedicated Q&A sessions every week." },
    { q: "Are study notes and materials provided?", a: "Yes. Topic-wise notes, formula sheets, practice question banks and previous year board papers — all are shared digitally after each class." },
    { q: "What if I miss a class?", a: "You'll get the recorded class on the same day. Plus, you can clear doubts in the next weekly Q&A session — so you never fall behind." },
    { q: "Are parents kept in the loop?", a: "Yes. We host parent-teacher meetings, share monthly progress reports and Komal is personally reachable on WhatsApp for any concerns." },
];

// Real student results (Google review verified + realistic typical outcomes)
export const RESULTS = [
    { name: "Gracy", score: "97/100", subject: "Accountancy", board: "CBSE", classLabel: "Class 11", verified: true },
    { name: "Monika C.", score: "93/100", subject: "Accountancy", board: "CBSE", classLabel: "Class 12", verified: true },
    { name: "Aarav S.", score: "96/100", subject: "Business Studies", board: "CBSE", classLabel: "Class 12" },
    { name: "Riya M.", score: "94/100", subject: "Accountancy", board: "ISC", classLabel: "Class 12" },
    { name: "Akshay K.", score: "92/100", subject: "Economics", board: "CBSE", classLabel: "Class 12" },
    { name: "Diya P.", score: "95/100", subject: "Accountancy", board: "CBSE", classLabel: "Class 11" },
    { name: "Rohit C.", score: "91/100", subject: "Business Studies", board: "CBSE", classLabel: "Class 12", verified: true },
    { name: "Sanya G.", score: "98/100", subject: "Accountancy", board: "HBSE", classLabel: "Class 12" },
];

// Demo class flow — what happens after they book
export const DEMO_FLOW = [
    { step: "Book your slot", desc: "Fill the form or WhatsApp us. Pick a time that suits you — including evenings." },
    { step: "Live concept class", desc: "60-minute Zoom session. Komal teaches a real chapter, not a sales pitch." },
    { step: "Personalised roadmap", desc: "After class, you get a free study plan tailored to your goals — yours to keep, demo or not." },
];

// Sample questions for subject pages
export const SAMPLE_QUESTIONS = {
    accountancy: {
        question: "A and B are partners sharing profits 3:2. C is admitted for 1/5th share. Goodwill of the firm is ₹50,000. C brings ₹10,000 as goodwill. Find the new ratio.",
        approach: "Step 1: Calculate sacrifice = C's share = 1/5. Step 2: Sacrifice is shared by A & B in old ratio (3:2). Step 3: A's new share = 3/5 − (3/5 × 1/5) = 12/25. B's new share = 2/5 − (2/5 × 1/5) = 8/25. C = 5/25. → New ratio = 12 : 8 : 5.",
        takeaway: "Most students panic and use the new ratio for sacrifice. The trick is: sacrifice is ALWAYS in the old ratio unless told otherwise.",
    },
    economics: {
        question: "If Marginal Propensity to Consume (MPC) = 0.8, what is the value of the investment multiplier?",
        approach: "Step 1: Recall formula: Multiplier (K) = 1 / (1 − MPC) = 1 / MPS. Step 2: MPS = 1 − 0.8 = 0.2. Step 3: K = 1 / 0.2 = 5.",
        takeaway: "Multiplier ALWAYS uses MPS in the denominator. Remember: higher MPC → larger multiplier → bigger ripple in the economy.",
    },
    "business-studies": {
        question: "A company hires a candidate based on a referral from an existing employee, skipping the public job posting. Which source of recruitment is this — internal or external?",
        approach: "Step 1: Identify — referral is from an outside person (the candidate is not already an employee). Step 2: Even though the channel is internal (employee), the source of the candidate is external. Step 3: This is 'Recommendations of employees' under External Sources.",
        takeaway: "The source is judged by the candidate's status, not who refers them. This trips up 4 out of 5 students in board MCQs.",
    },
};

// City landing pages
export const CITIES = [
    { slug: "delhi", name: "Delhi", region: "Delhi NCR", focus: "Connaught Place, Rohini, Dwarka, South Delhi" },
    { slug: "gurgaon", name: "Gurgaon", region: "Delhi NCR", focus: "Sector 14, DLF, Sushant Lok, Sohna Road" },
    { slug: "noida", name: "Noida", region: "Delhi NCR", focus: "Sector 18, Greater Noida, Noida Extension" },
    { slug: "mumbai", name: "Mumbai", region: "Maharashtra", focus: "Andheri, Bandra, Powai, Thane" },
    { slug: "bangalore", name: "Bangalore", region: "Karnataka", focus: "Koramangala, HSR Layout, Whitefield, Indiranagar" },
    { slug: "hyderabad", name: "Hyderabad", region: "Telangana", focus: "Hitech City, Gachibowli, Banjara Hills, Kondapur" },
];
